import LineChart from "./LineChart"
import { CircularProgress } from "@mui/material"

function LineDashboard({ darkMode, data }) {
    return (
        <>
            {data.labels !== undefined
                ? (
                    <div style={{ width: "100%" }}>
                        <LineChart
                            darkMode={darkMode}
                            chart={data}
                            backgroundColor="F4F6FB"
                        />
                    </div>
                ) : (
                    <div
                        style={{
                            width: "100%",
                            minHeight: 180,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <CircularProgress
                            size={56}
                            thickness={4.5}
                            style={{ color: "#9ba5b0", marginBottom: 16 }}
                        />
                    </div>
                )}
        </>
    )
}

export default LineDashboard